type UrlComponents = {
	path: string;
	query: string;
};

export class Router {
	get path(): string {
		return this._getUrlComponents().path;
	}

	get query(): string {
		return this._getUrlComponents().query;
	}

	get topDomain(): string | undefined {
		const hostName = window.location.hostname;
		const hostNameSplit = hostName.split(".");
		const topDomain = hostNameSplit[hostNameSplit.length - 1];

		if (
			!topDomain ||
			topDomain === "" ||
			hostName.indexOf(".") === -1 ||
			/\d/.test(topDomain)
		) {
			return undefined;
		}

		return topDomain.toLowerCase();
	}

	get url(): string {
		return window.location.href;
	}

	public getQueryParam(param: string): string {
		const query = this._getUrlComponents().query;
		const paramBegin = query.indexOf(param);
		let result = "";

		if (paramBegin >= 0) {
			result = query.slice(paramBegin).split("=")[1];
			result = result && result.split("&", 1)[0];
		}

		return result || "";
	}

	public updatePath(path: string): void {
		const currentPath = this.path;

		if (path !== currentPath) {
			const query = this.query;
			this._updateUrl(path, query);
		}
	}

	public updateQuery(query: string): void {
		const currentQuery = this.query;

		if (query !== currentQuery) {
			const path = this.path;
			this._updateUrl(path, query);
		}
	}

	public updatePathAndQuery(path: string, query: string): void {
		const currentPath = this.path;
		const currentQuery = this.query;

		if (query !== currentQuery || path !== currentPath) {
			this._updateUrl(path, query);
		}
	}

	public addListener(listener: (event: HashChangeEvent) => void): void {
		window.addEventListener("hashchange", listener);
	}

	public removeListener(listener: (event: HashChangeEvent) => void): void {
		window.removeEventListener("hashchange", listener);
	}

	private _updateUrl(path: string, query: string) {
		let url = `${window.location.origin}${window.location.pathname}#/${path}`;
		if (query.length > 0) {
			url = `${url}?${query}`;
		}

		window.history.replaceState(null, "", url);
	}

	private _getUrlComponents(): UrlComponents {
		const urlComponents = window.location.hash.split("?");

		let path = urlComponents[0];
		path = path ? path.split("#/")[1] : "";

		return {
			path,
			query: urlComponents[1] || "",
		};
	}
}
